import React from 'react';
import Front from './front';
import close from './img/close-circle-line.png'
import api from './apiConnector'

class FrontOverlay extends React.Component {
    
  constructor(props) {
      super(props);
      this.state = {
        devis:false
      }
  }

  componentDidMount() {
    api.registerFrontOverlay(this)
  }

  componentWillUnmount() {
    api.unregisterFrontOverlay(this)
  }

  open(devis) {
    this.setState({devis:devis})
  }

  render() {
    if ( !this.state.devis ) return <></>
    const {_id,params,type} = this.state.devis
    return <><div className="front_overlay_back" onClick={this.open.bind(this,false)}>
        </div>
          <div className="front_overlay">
            <div className="front_overlay_header" onClick={this.open.bind(this,false)}>
              <img src={close}/>
              {params.nom} {params.prenom} 
              <span><a target="_blank" href={api.frontUrl(type+_id.$oid)}>Interface client ▸</a></span>
            </div>
            <div className="front_overlay_container">
              <Front type={type} id={_id.$oid} embeded={true} operator={this.props.operator}/>
            </div>
        </div>
        </>
  }
}

export default FrontOverlay;
